import type { Language } from '@backend/lib-l10n';

import en from '~/locales/en';
import fr from '~/locales/fr';
import it from '~/locales/it';
import type { Translations } from '~/utils/translations/types';

export const locales: Partial<Record<Lowercase<Language>, Translations>> = { en, fr, it };
